import { render } from "./banner_page_list.vue?vue&type=template&id=4e0e79c0"
import script from "./banner_page_list.vue?vue&type=script&lang=js"
export * from "./banner_page_list.vue?vue&type=script&lang=js"

import exportComponent from "D:\\svn\\esp-rms-xhjr-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__